module.exports = __webpack_public_path__ + "img/Keep a track on the process.9d62970.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Keep a track on the process.png
// module id = 1201
// module chunks = 1